<h2 style="margin:5px 0 10px 0;">Create a New Location Set Type</h2>
<form [formGroup]="form" novalidate (ngSubmit)="OnSubmit()">
  <table class="attribute-full-width" cellspacing="2">
    <tr>
      <td>
        <mat-form-field>
          <input
            [attr.data-testid]="'name_text'"
            formControlName="name"
            matInput
            [pattern]="spaceValidatorPattern"
            placeholder="Name"
            required
            >
          @if (form.controls['name'].invalid) {
            <mat-error>Please enter a Name</mat-error>
          }
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <input
            [attr.data-testid]="'tag_text'"
            formControlName="tag"
            matInput
            pattern="^[A-Z_0-9]*$"
            placeholder="Tag"
            required
            (focusout)="findTagExists()"
            >
          @if (form.controls['tag'].invalid && !form.controls['tag'].value) {
            <mat-error>
              Please enter a Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.pattern && form.controls['tag'].value) {
            <mat-error>
              Please enter a Valid Standard Tag
            </mat-error>
          }
          @if (form.controls['tag'].errors?.tagExists && form.controls['tag'].touched) {
            <mat-error>
              Tag already exists! Create a new one.
            </mat-error>
          }
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <input
            [attr.data-testid]="'weight_text'"
            formControlName="weight"
            matInput
            pattern="^[0-9]+(\.[0-9]{1,2})?$"
            placeholder="Weight"
            required
            type="number"
            >
          @if (form.controls['weight'].invalid && !form.controls['weight'].value) {
            <mat-error>
              Please enter a Value
            </mat-error>
          }
          @if (form.controls['weight'].errors?.pattern && form.controls['weight'].value) {
            <mat-error>
              Please enter a Valid Value
            </mat-error>
          }
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <textarea
            #message
            [attr.data-testid]="'description_textarea'"
            formControlName="description"
            matInput
            maxlength="256"
            placeholder="Description"
          ></textarea>
          <mat-hint align="end">{{ message.value.length }} / 256</mat-hint>
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <mat-select
            [attr.data-testid]="'locked_select'"
            formControlName="locked"
            matTooltip="This will prevent deletion of the location-set-type"
            placeholder="Locked"
            >
            <mat-option [attr.data-testid]="'locked_true_option'" [value]="true">True</mat-option>
            <mat-option [attr.data-testid]="'locked_false_option'" [value]="false">False</mat-option>
          </mat-select>
        </mat-form-field>
      </td>
    </tr>
  </table>
  <div  style="margin-top: 30px;" class="flex-center-center">
    <button
      [attr.data-testid]="'cancel_button'"
      class="button-color"
      mat-raised-button
      matTooltip="Cancel creating LocationSetType"
      style="margin-right: 60px;"
      type="button"
      (click)="onNoClick()"
    >Cancel</button>
    <button
      [attr.data-testid]="'save_button'"
      class="button-color"
      mat-raised-button
      matTooltip="Save"
      type="submit"
      [disabled]="isReadOnly | async"
    >Save</button>
  </div>
</form>
